import { GQLErrorCode } from "graphql.generated";
import { TFunction } from "next-i18next";

export function resolveBusinessError(errorCode: GQLErrorCode, t: TFunction): string {
    switch (errorCode) {
        case GQLErrorCode.ChannelNotConnected:
            return t("error.channelNotConnected", {
                defaultValue: "The channel is not connected. Please connect the channel first.",
            });
        case GQLErrorCode.ChannelNotSupported:
            return t("error.channelNotSupported", {
                defaultValue: "This channel is not supported.",
            });
        case GQLErrorCode.ConnectorNotConfigured:
            return t("error.connectorNotConfigured", {
                defaultValue: "The connector is not configured. Please contact support.",
            });
        case GQLErrorCode.DisconnectFailed:
            return t("error.disconnectFailed", {
                defaultValue: "Failed to disconnect the channel. Please try again.",
            });
        case GQLErrorCode.InvalidState:
            return t("error.invalidState", {
                defaultValue: "Invalid state detected. Please try again.",
            });
        case GQLErrorCode.OauthCompleteFailed:
            return t("error.oauthCompleteFailed", {
                defaultValue: "Failed to complete authentication. Please try again.",
            });
        case GQLErrorCode.OauthInitFailed:
            return t("error.oauthInitFailed", {
                defaultValue: "Failed to start authentication. Please try again.",
            });
        case GQLErrorCode.ProviderNotFound:
            return t("error.providerNotFound", {
                defaultValue: "The provider could not be found.",
            });
        case GQLErrorCode.StateChannelMismatch:
            return t("error.stateChannelMismatch", {
                defaultValue: "State mismatch detected. Please try again.",
            });
        case GQLErrorCode.StateUserMismatch:
            return t("error.stateUserMismatch", {
                defaultValue: "User mismatch detected. Please try again.",
            });
        case GQLErrorCode.TokenExchangeFailed:
            return t("error.tokenExchangeFailed", {
                defaultValue: "Failed to exchange authentication token. Please try again.",
            });
        case GQLErrorCode.Unauthenticated:
            return t("error.unauthenticated", {
                defaultValue: "You are not authenticated. Please log in.",
            });
        case GQLErrorCode.UserNotFound:
            return t("error.userNotFound", {
                defaultValue: "User not found.",
            });
        default:
            return t("error.general", {
                defaultValue: "Something went wrong. Please try again later.",
            });
    }
}
